import CompanyActionTypes from "./company.types";

// const INITIAL_STATE = { userId: null, username: null };
const INITIAL_STATE = {
  companiesList: [],
  selectedCompany: {},
};

const companyReducer = (state = INITIAL_STATE, action) => {
  console.log(action);
  switch (action.type) {
    case CompanyActionTypes.RETRIEVE_COMPANIES:
      return { ...state, ...action.payload };
    case CompanyActionTypes.RETRIEVE_COMPANY_DETAILS:
      return {
        ...state,
        ...{ selectedCompany: { ...state.selectedCompany, ...action.payload } },
      };
    default:
      return state;
  }
};

export default companyReducer;
